export function formatPrice(price: number, currency: string, locale: string = 'ru-RU'): string {
  const roundedPrice = Math.ceil(price);

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency.toUpperCase(),
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(roundedPrice);
}
